<div class="schedule-pickup-container position-relative text-center">
  <img src="/assets/img/dummy-image/2560x1022.png" alt="" class="img-fluid" />
</div>

<div class="booking-form-container">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <!-- Progress Steps -->
        <div class="steps-container mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <div
              class="step"
              [class.active]="currentStep >= 1"
              [class.completed]="currentStep > 1"
            >
              <div class="step-number">1</div>
              <div class="step-title">Sender</div>
            </div>
            <div class="step-line" [class.completed]="currentStep > 1"></div>
            <div
              class="step"
              [class.active]="currentStep >= 2"
              [class.completed]="currentStep > 2"
            >
              <div class="step-number">2</div>
              <div class="step-title">Consignee</div>
            </div>
            <div class="step-line" [class.completed]="currentStep > 2"></div>
            <div class="step" [class.active]="currentStep >= 3">
              <div class="step-number">3</div>
              <div class="step-title">Box and Items</div>
            </div>
          </div>
        </div>

        <!-- Form -->
        <form [formGroup]="bookingForm" (ngSubmit)="onSubmit()">
          <!-- Step 1: Sender -->
          <div class="step-content" *ngIf="currentStep === 1">
            <h3 class="mb-4">Step 1: Sender</h3>
            <p class="text-muted mb-4">
              Please fill out the form below with all the information below for
              your collection pickup! All out the sender information only, your
              tracking.
            </p>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">First Name *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="senderFirstName"
                  placeholder="First Name"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Last Name *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="senderLastName"
                  placeholder="Last Name"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Email *</label>
                <input
                  type="email"
                  class="form-control"
                  formControlName="senderEmail"
                  placeholder="Email"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Phone Number *</label>
                <input
                  type="tel"
                  class="form-control"
                  formControlName="senderPhone"
                  placeholder="Phone Number"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Address *</label>
                <textarea
                  class="form-control"
                  rows="3"
                  formControlName="senderAddress"
                  placeholder="Street Address"
                ></textarea>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Apt Address (Optional)</label>
                <textarea
                  class="form-control"
                  rows="3"
                  formControlName="senderAddress2"
                  placeholder="Apartment, suite, unit, building"
                ></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">Country *</label>
                <select class="form-control" formControlName="senderCountry">
                  <option value="">Select Country</option>
                  <option value="US">United States</option>
                  <option value="CA">Canada</option>
                  <option value="UK">United Kingdom</option>
                </select>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">State *</label>
                <select class="form-control" formControlName="senderState">
                  <option value="">Select State</option>
                  <option value="CA">California</option>
                  <option value="NY">New York</option>
                  <option value="TX">Texas</option>
                </select>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">City *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="senderCity"
                  placeholder="Enter City"
                />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Zip Code *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="senderZipCode"
                  placeholder="Zip Code"
                />
              </div>
            </div>
          </div>

          <!-- Step 2: Consignee -->
          <div class="step-content" *ngIf="currentStep === 2">
            <h3 class="mb-4">Step 2: Consignee</h3>
            <p class="text-muted mb-4">Fill out consignee information</p>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">First Name *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="consigneeFirstName"
                  placeholder="First Name"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Last Name *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="consigneeLastName"
                  placeholder="Last Name"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label"
                  >1st Telephone Number (Optional)</label
                >
                <input
                  type="tel"
                  class="form-control"
                  formControlName="consigneePhone"
                  placeholder="Phone Number"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label"
                  >2nd Telephone Number (Optional)</label
                >
                <input
                  type="tel"
                  class="form-control"
                  formControlName="consigneePhone2"
                  placeholder="Second Phone Number"
                />
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Provide Complete Address Below *</label>
              <textarea
                class="form-control"
                rows="4"
                formControlName="consigneeAddress"
                placeholder="Address..."
              ></textarea>
            </div>

            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label">State/Province *</label>
                <select class="form-control" formControlName="consigneeState">
                  <option value="">State/Province</option>
                  <option value="CA">California</option>
                  <option value="NY">New York</option>
                  <option value="TX">Texas</option>
                </select>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">City *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="consigneeCity"
                  placeholder="Enter city"
                />
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label">Postal Code *</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="consigneeZipCode"
                  placeholder="Postal Code"
                />
              </div>
            </div>
          </div>

          <!-- Step 3: Box Size -->
          <div class="step-content" *ngIf="currentStep === 3">
            <h3 class="mb-4">Step 3: Box & Items</h3>
            <p class="text-muted mb-4">Select package size and add boxes</p>

            <div class="row justify-content-between align-items-end">
              <div class="col-md-6 mb-3">
                <label class="form-label">Service Type *</label>
                <select class="form-control" formControlName="serviceType">
                  <option value="">Select Service Type</option>
                  <option value="PICKUP">Pick Up</option>
                  <option value="DROPOFF">Drop Off</option>
                </select>
              </div>

              <div class="col-auto mb-3">
                <button
                  class="btn add-box-btn"
                  type="button"
                  (click)="openAddBoxModal()"
                  [disabled]="!bookingForm.get('serviceType')?.valid"
                >
                  Add Box
                </button>
              </div>
            </div>

            <!-- List of added boxes -->
            <div *ngIf="boxes.length > 0" class="mt-3">
              <h5>Added Boxes</h5>
              <div class="row">
                <div
                  class="col-12 col-md-6 col-lg-4 mb-3"
                  *ngFor="let box of boxes.controls; let i = index"
                >
                  <div class="card h-100 text-center">
                    <img
                      [src]="
                        boxImages[box.value.boxSize] ||
                        'assets/img/boxes/default.png'
                      "
                      class="card-img-top p-3"
                      alt="{{ box.value.boxSize }}"
                      style="max-height: 150px; object-fit: contain"
                    />
                    <div class="card-body">
                      <h6 class="card-title mb-1">Box {{ i + 1 }}</h6>
                      <p class="card-text mb-2">
                        <strong>{{ box.value.boxSize }} </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="d-flex justify-content-between mt-4">
            <button
              type="button"
              class="btn btn-secondary"
              *ngIf="currentStep > 1"
              (click)="prevStep()"
            >
              Previous
            </button>
            <div></div>
            <button
              type="button"
              class="btn btn-primary"
              *ngIf="currentStep < totalSteps"
              [disabled]="!isStepValid(currentStep)"
              (click)="nextStep()"
            >
              Next Step
            </button>
            <button
              type="submit"
              class="btn btn-danger"
              *ngIf="currentStep === totalSteps"
              [disabled]="!isStepValid(currentStep)"
              (click)="debugForm()"
            >
              Book Now
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Add/Edit Box Modal -->
<div class="modal fade" id="addBoxModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add/Edit Box</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="addBoxForm">
          <!-- Box Size -->
          <div class="mb-3">
            <label class="form-label">Box Size</label>
            <select class="form-control" formControlName="boxSize">
              <option value="">Select Box Size</option>
              <option value="DOYDOY">Doy Doy Box</option>
              <option value="POPBOX">Pop Box</option>
              <option value="ALIBOX">Ali Box</option>
              <option value="HANNAHBOX">Hannah Box</option>
              <option value="IRREGULARBOX">Irregular Box</option>
            </select>
          </div>

          <!-- Box Items -->
          <div>
            <label class="form-label">Box Items</label>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Item</th>
                  <th style="width: 80px">Qty</th>
                  <th style="width: 100px">Price</th>
                  <th style="width: 120px">Condition</th>
                  <th style="width: 50px"></th>
                </tr>
              </thead>
              <tbody formArrayName="items">
                <tr
                  *ngFor="let item of items.controls; let i = index"
                  [formGroupName]="i"
                >
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="description"
                      placeholder="Description"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="qty"
                      min="1"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="price"
                      min="1"
                    />
                  </td>
                  <td>
                    <select class="form-control" formControlName="condition">
                      <option value="New">New</option>
                      <option value="Used">Used</option>
                    </select>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      (click)="removeItem(i)"
                    >
                      X
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" class="btn btn-danger" (click)="addItem()">
              Add New Item
            </button>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="saveBox()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
